export default "__VITE_ASSET__CATeTp9Z__"